import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const location = useLocation();
  const nav = useNavigate();
  const { googleSession } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const params = new URLSearchParams((location.hash || "").replace(/^#/, ""));
    const sessionId = params.get("session_id");
    if (!sessionId) {
      nav("/auth", { replace: true });
      return;
    }
    (async () => {
      try {
        await googleSession(sessionId);
        window.history.replaceState({}, "", "/plaza");
        toast.success("Welcome to BiblePlaza");
        nav("/plaza", { replace: true });
      } catch {
        toast.error("Google sign-in failed. Please try again.");
        nav("/auth", { replace: true });
      }
    })();
  }, []);

  return (
    <div className="grid min-h-screen place-items-center text-[#6B6763]" data-testid="auth-callback">
      Signing you in…
    </div>
  );
}
